// Chrome/Edge spin the value of a FOCUSED <input type="number"> when the mouse wheel
// turns over it — on data-heavy pages (e.g. Pricing Detail) scrolling past a just-edited
// field silently changes its value. Kill the spin globally: cancel the wheel's default
// action on the focused number input and blur it, so the very next wheel tick scrolls
// the page as the user expects.
// Document-level capture listener (like patchResizeObserver): React's synthetic onWheel
// is registered passive, so preventDefault only works from a native passive:false listener.
document.addEventListener(
  'wheel',
  (event) => {
    const target = event.target;
    if (target instanceof HTMLInputElement && target.type === 'number' && target === document.activeElement) {
      event.preventDefault();
      target.blur();
    }
  },
  { capture: true, passive: false }
);
